import React, { useState } from 'react';
import { HeroSection } from './components/HeroSection';
import { EmotionalSection } from './components/EmotionalSection';
import { ProblemSection } from './components/ProblemSection';
import { MethodSection } from './components/MethodSection';
import { PlanSection } from './components/PlanSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { BridgeSection } from './components/BridgeSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FinalCTASection } from './components/FinalCTASection';
import { PrivacyPopup, PopupType } from './components/PrivacyPopup';
export function App() {
  const [openPopup, setOpenPopup] = useState<PopupType>(null);
  return <main className="min-h-screen bg-[#FAFAF8] font-lato text-[#1a1a2e]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmotionalSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <MethodSection data-id="element-4" />
      <PlanSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <BenefitsSection data-id="element-7" />
      <ObjectionsSection data-id="element-8" />
      <BridgeSection data-id="element-9" />
      <PricingSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <FinalCTASection data-id="element-12" />

      {/* Footer */}
      <footer className="bg-[#1a1a2e] text-gray-500 py-8 text-center text-sm border-t border-gray-800" data-id="element-13">
        <div className="container mx-auto px-4" data-id="element-14">
          <p className="mb-3" data-id="element-15">
            © {new Date().getFullYear()} El Interruptor Digital. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-16">
            <button onClick={() => setOpenPopup('privacy')} className="hover:text-white transition-colors underline decoration-gray-600 underline-offset-4" data-id="element-17">
              Política de Privacidad
            </button>
            <span className="text-gray-700" data-id="element-18">·</span>
            <button onClick={() => setOpenPopup('terms')} className="hover:text-white transition-colors underline decoration-gray-600 underline-offset-4" data-id="element-19">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <PrivacyPopup openPopup={openPopup} onClose={() => setOpenPopup(null)} data-id="element-20" />
    </main>;
}